export const OnboardingButtons: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <div className="flex flex-col justify-end gap-3 md:flex-row md:items-center">{children}</div>
  )
}
